var map = {
	"./template.bet575": 2067,
	"./template.bet575.tsx": 2067,
	"./template.bet777": 2068,
	"./template.bet777.tsx": 2068,
	"./template.betprofessor": 2069,
	"./template.betprofessor.tsx": 2069,
	"./template.betroyale": 2070,
	"./template.betroyale.tsx": 2070,
	"./template.betstride": 2071,
	"./template.betstride.tsx": 2071,
	"./template.buffalobet": 2072,
	"./template.buffalobet.tsx": 2072,
	"./template.chromabet": 2073,
	"./template.chromabet.tsx": 2073,
	"./template.default": 672,
	"./template.default.tsx": 672,
	"./template.epicodds": 2074,
	"./template.epicodds.tsx": 2074,
	"./template.fiestabet": 2075,
	"./template.fiestabet.tsx": 2075,
	"./template.forsport": 1631,
	"./template.forsport.tsx": 1631,
	"./template.gigabet": 2076,
	"./template.gigabet.tsx": 2076,
	"./template.goldenbet888": 2077,
	"./template.goldenbet888.tsx": 2077,
	"./template.goldenrush": 2078,
	"./template.goldenrush.tsx": 2078,
	"./template.hyperbet": 2079,
	"./template.hyperbet.tsx": 2079,
	"./template.juicybet": 2080,
	"./template.juicybet.tsx": 2080,
	"./template.junglebet": 2081,
	"./template.junglebet.tsx": 2081,
	"./template.magnumbet": 2082,
	"./template.magnumbet.tsx": 2082,
	"./template.oldgill": 2083,
	"./template.oldgill.tsx": 2083,
	"./template.puntcity": 2084,
	"./template.puntcity.tsx": 2084,
	"./template.puntgenie": 2085,
	"./template.puntgenie.tsx": 2085,
	"./template.pyramidbet": 2086,
	"./template.pyramidbet.tsx": 2086,
	"./template.questbet": 2087,
	"./template.questbet.tsx": 2087,
	"./template.slambet": 2088,
	"./template.slambet.tsx": 2088,
	"./template.sterlingparker": 2089,
	"./template.sterlingparker.tsx": 2089,
	"./template.sugarcastle": 2090,
	"./template.sugarcastle.tsx": 2090,
	"./template.templebet": 2091,
	"./template.templebet.tsx": 2091,
	"./template.titanbet": 2092,
	"./template.titanbet.tsx": 2092,
	"./template.ts": 986,
	"./template.vikingbet": 2093,
	"./template.vikingbet.tsx": 2093,
	"./template.volcanobet": 2094,
	"./template.volcanobet.tsx": 2094,
	"./template.wellbet": 2095,
	"./template.wellbet.tsx": 2095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;